

import { DialogRecorderIdRegistryService } from "src/app/shared/services/dialog-recorder-id-registry.service";
import { BlocklyHelperService } from "../blockly-helper.service";
import { adjustColorBrightness, BLOCKLY_BLOCK_PREFIX, BLOCKLY_CARD_PREFIX, BLOCKLY_COLORS, BLOCKLY_DUMMY, BlocklyToolboxCategory } from "../blocky-types.types";
import { registerDialogRecorderIdDropdownBlock } from "../field-dialog-recorder-id-dropdown";
import { OVERLAY_PLACEMENT } from "./overlays.category";

export function BlocklyCategory_MESSAGES(name: string = "unnamed", BH: BlocklyHelperService): BlocklyToolboxCategory {
  const cat: BlocklyToolboxCategory = { kind: 'category', colour: BLOCKLY_COLORS.MESSAGES, name: name, contents: [] };

  return cat;
}



export function BlocklyCategory_HELPERS_CONTROL(name: string = "unnamed", BH: BlocklyHelperService, icon?: string) {
  const cat: BlocklyToolboxCategory = { kind: 'category', colour: adjustColorBrightness(BLOCKLY_COLORS.CAT_START_ABLAUF, 20), name: name, contents: [] };

  // Blöcke registrieren die im vordefinierten Stack verwendet werden
  //BH.message("SEND_PROMPT_TXT", "Prompt Senden: {{value}}", "await RAGAI.MSG.prompt({{value}});");

  cat.contents = [
    // das ist der wichtige start bloc
    BH.startBlockNew('MY_START_BLOCK', "{{type:dropdown=sobald der Bot bereit ist|await RAGAI.WAITFOR.initialIdle();,sofort|}}", '{{type}}', false, icon),
    BH.action("BOT_CONTROLS_RESTART", "Bot von vorne starten (Neustart)", "await RAGAI.restartBot();"),
    BH.withNested(
      BH.action("WAITFOR_SECONDS_NEW", "Zeit abwarten: {{ time[@check=SECONDS] }}", "await RAGAI.WAITFOR.seconds({{time}});"),
      [{ forValue: 'time', isShadow: true, targetBlockType: BLOCKLY_DUMMY.SECONDS }]
    ),
    BH.withNested(
      BH._custom("BOT_CONTROLS_ENDBOT", "Bot beenden\nTitel:{{?title}}\nNachricht:{{?message}}\nWeiterleitung nach (Sek):{{?autoRedirectSeconds}}\nWeiterleitungs-URL:{{?redirectUrl}}\nWeiterleitungs-Titel:{{?redirectTitle}}", "RAGAI.HELPER.endBot({ title: {{title}}, message: {{message}}, autoRedirectSeconds: {{autoRedirectSeconds}}, redirectUrl: {{redirectUrl}}, redirectTitle: {{redirectTitle}} });", { colour: BLOCKLY_COLORS.ACTIONS }),
      [
        { forValue: "title", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Bot beendet" } },
        { forValue: "message", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Bot wurde beendet" } },
        { forValue: "autoRedirectSeconds", isShadow: true, targetBlockType: BLOCKLY_DUMMY.NUMBER, targetBlockDefaults: { num: -1 } },
        { forValue: "redirectUrl", isShadow: true, targetBlockType: BLOCKLY_DUMMY.URL },
        { forValue: "redirectTitle", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "" } }
      ]
    ),

    // Vordefinierter Block-Stack: "Willkommensnachricht" als Kombination
    {
      kind: 'block',
      type: 'RAG_IF',
      inputs: {
        a: {
          block: {
            type: 'RAG_CONDITION_CHAT_HISTORY_EMPTY'
          }
        }

      }
    } as any,

    // Demo: Hidden Fields – Felder die erst per Chevron-Klick sichtbar werden
    BH.label("Eigenschaften und Werte"),
    BH._custom("BOT_NAME", "@output:String\nName des Bots", `RAGAI.HELPER.botService.botConfig.name`, { colour: BLOCKLY_COLORS.PROPERTIES }),
    BH._custom("BOT_MODEL", "@output:String\nKI-Modell des Bots", `RAGAI.HELPER.botService.botConfig.model`, { colour: BLOCKLY_COLORS.PROPERTIES }),
    BH._custom("BOT_TEMPERATURE", "@output:Number\nTemperature des Bots", `RAGAI.HELPER.botService.botConfig.temperature`, { colour: BLOCKLY_COLORS.PROPERTIES }),
    BH._custom("RAG_CONDITION_CHAT_HISTORY_EMPTY", "@output:Boolean\nChatverlauf {{state:dropdown=ist|===,ist nicht|!==}} leer" + BLOCKLY_BLOCK_PREFIX.IF_CONDITION, "RAGAI.INFO.messagesCount() {{state}} 0", { inputsInline: true, colour: BLOCKLY_COLORS.IF_CONDITION }),
    BH._custom("INFO_MESSAGECOUNT", "@output:Number\nAnzahl der Nachrichten im Chatverlauf", `RAGAI.INFO.messagesCount()`, { colour: BLOCKLY_COLORS.PROPERTIES })

  ];
  return cat;
}




export function BlocklyCategory_HELPERS_GROUP(name: string = "unnamed", BH: BlocklyHelperService) {
  const cat: BlocklyToolboxCategory = { kind: 'category', name: name, contents: [] };
  cat.contents = [


    BH._custom("GROUP", "Gruppe  {{comment:text}} \n{{content:statement}}", "/* ===============\n Notiz: {{comment}}; \n===============*/ \n{{content}} ", { colour: BLOCKLY_COLORS.PROPERTIES }),
    BH._custom("COMMENT", "Notiz  {{comment:text}}", "/* ===============\n Notiz: {{comment}}; \n===============*/", { colour: BLOCKLY_COLORS.PROPERTIES }),
    BH.withNested(
      BH._custom("OWN_FUNCTION_DEFINITION", BLOCKLY_BLOCK_PREFIX.ACTIONS + "eigene Aktion definieren:{{name}} \n{{content:statement}} und sofort ausführen{{triggernow:checkbox}}", "RAGAI.FUNCTIONS[{{name}}] = async function(){ {{content}} };\n if({{triggernow}}){ await RAGAI.FUNCTIONS[{{name}}](); }", { colour: BLOCKLY_COLORS.ACTIONS }),
      [{ forValue: "name", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "meineAktion" } }]
    ),

    BH.withNested(
      BH.action("OWN_FUNCTION_CALL", "Aktion ausführen {{name}}\nErgebnis abwarten{{?doAwait:checkbox=false}}", "if({{doAwait}}){ await RAGAI.FUNCTIONS[{{name}}](); } else { RAGAI.FUNCTIONS[{{name}}](); }"),
      [{ forValue: "name", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "meineAktion" } }])
  ];
  return cat;
}

export function BlocklyCategory_HELPERS_DIALOGRECORDER(name: string = "unnamed", BH: BlocklyHelperService, dialogRecorderIdRegistry: DialogRecorderIdRegistryService) {
  const cat: BlocklyToolboxCategory = { kind: 'category', colour: BLOCKLY_COLORS.DIALOGRECORDER, name: name, contents: [] };
  BH.setCategoryContext(BLOCKLY_COLORS.DIALOGRECORDER);

  // Alte Blöcke nur registrieren (veraltet – werden grau dargestellt)
  BH._custom("DIALOGRECORDER_actions", "🎙️ Dialog Recorder {{c:dropdown=Start|record(),Stop|stop(),zurücksetzen|reset()}}", "await RAGAI.DIALOGRECORDER.{{c}};", { colour: BLOCKLY_COLORS.DIALOGRECORDER });
  BH.withNested(
    BH._custom("DIALOGRECORDER_OVERRIDE_USER_NAMES", "🎙️ Dialog Recorder:\n Überschreibe Namen im Dialog: \n User: {{userName}} Bot: {{botName}}", "RAGAI.DIALOGRECORDER.USER_NAME = {{userName}};\nRAGAI.DIALOGRECORDER.BOT_NAME = {{botName}};", { colour: BLOCKLY_COLORS.DIALOGRECORDER }),
    [{ forValue: "userName", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "User" } },
    { forValue: "botName", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Bot" } }]
  );
  BH._custom("DIALOGRECORDER_getDialogHtml", "@output:String\n🎙️ Hole aufgezeichneten Dialog als {{c:dropdown=Text|getDialog(),HTML|getDialogHtml(),Json|getDialogJson()}}", " await RAGAI.DIALOGRECORDER.{{c}}", { colour: BLOCKLY_COLORS.DIALOGRECORDER });

  // Recorder-ID-Dropdown registrieren (idempotent)
  registerDialogRecorderIdDropdownBlock(dialogRecorderIdRegistry);

  // DIALOGRECORDER_actions_NEW nur registrieren (durch zwei neue Blöcke abgelöst)
  BH._custom(
    "DIALOGRECORDER_actions_NEW",
    "🎙️ Dialog Recorder {{c:dropdown=▶️ Starten|record,⏹ Stoppen|stop,🔄 Zurücksetzen|reset}}\nMerken als: {{recorderId:text}}",
    "await RAGAI.DIALOGRECORDER.{{c}}({{recorderId}});",
    { colour: BLOCKLY_COLORS.DIALOGRECORDER }
  );

  cat.contents = [
    // Dialog Recorder starten – mit "Merken als"-ID
    BH._custom(
      "DIALOGRECORDER_start_NEW",
      "Dialog Mitschnitt einrichten - ID: {{recorderId:text}} \n  Aufzeichnung sofort starten {{?startrecord:checkbox=false}}",
      `await RAGAI.DIALOGRECORDER.init({{recorderId}});
if ({{startrecord}}) {  await RAGAI.DIALOGRECORDER.record({{recorderId}}); }`,
      { colour: BLOCKLY_COLORS.DIALOGRECORDER }
    ),

    // Dialog Recorder stoppen oder zurücksetzen – ID per eingebettetem Dropdown
    { kind: 'block' as const, type: 'DIALOGRECORDER_control_NEW' },

    // Dialog als Text / HTML / JSON abrufen
    BH.withNested(
      { kind: 'block' as const, type: 'DIALOGRECORDER_getDialog_NEW' },
      [
        { forValue: "userName", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "User" } },
        { forValue: "botName", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Bot" } }
      ]
    )
  ];
  BH.clearCategoryContext();
  return cat;
}

export function BlocklyCategory_HELPERS_EXTRAS(name: string = "unnamed", BH: BlocklyHelperService) {
  const cat: BlocklyToolboxCategory = { kind: 'category', name: name, contents: [] };

  cat.contents = [
    BH._custom("CONFETTI", "🎉 Confetti", "RAGAI.confetti();", { colour: "#ff00ff" }),
    BH.withNested(
      BH._custom("CONFETTI_TEXT",
        `🎉 Confetti mit Einstellungen
      Text/Emoji:{{text}}
      Größe: {{size:number=2}}
      Anzahl: {{particleCount:number=30}}
      Dauer: {{ticks:number=60}}
      Schwerkraft: {{gravity:number=0}}
      `,
        `RAGAI.confetti({
  spread: 360,
  ticks: {{ticks}},
  gravity: {{gravity}},
  decay: 0.96,
  startVelocity: 20,
  particleCount: {{particleCount}},
  flat: true,
  scalar: {{size}},
  shapes: [RAGAI.confetti.shapeFromText({ text: {{text}}, scalar: {{size}} })]});`, { colour: "#ff00ff" }),
      [{ forValue: "text", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "🦄" } }]
    )
  ];
  return cat;
}

export function BlocklyCategory_HELPERS_DEBUG(name: string = "unnamed", BH: BlocklyHelperService) {
  const cat: BlocklyToolboxCategory = { kind: 'category', name: name, contents: [] };
  cat.contents = [
    BH.label("CODE"),
    BH._custom("RAG_RAW", "🌀 javascript: {{code:textarea}}", "{{code!}}", { colour: BLOCKLY_COLORS.CODE }),
    BH._custom("RAG_RAW_OUTPUT", "@output:String\n 🌀 javascript: {{code:textarea}}", "{{code!}}", { colour: BLOCKLY_COLORS.CODE }),
    BH.label("JSON"),
    BH.withNested(
      BH._custom("JSON_STRINGIFY", "@output:String\nJSON.stringify({{value}})", "JSON.stringify({{value}})", { colour: BLOCKLY_COLORS.CODE, inputsInline: true }),
      [{ forValue: "value", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "{}" } }]
    ),
    BH.withNested(
      BH._custom("JSON_PARSE", "@output:String\nJSON.parse({{value}})", "JSON.parse({{value}})", { colour: BLOCKLY_COLORS.CODE, inputsInline: true }),
      [{ forValue: "value", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "{}" } }]
    ),
    BH.withNested(
      BH._custom("JSON_GET_PROPERTY", `@output:String\nEigenschaft "{{key:text=name}}" aus JSON {{json}}`, `(function(o,p){return p.split('.').reduce(function(a,k){return a?.[k]},o)})({{json}},{{key}})`, { colour: BLOCKLY_COLORS.CODE, inputsInline: true }),
      [{ forValue: "json", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: '{"name":""}' } }]
    ),
    BH.label("Debugging"),
    BH.withNested(
      BH._custom("CONSOLE.log", "🌀 console.log({{value}})", "console.log({{value}});", { colour: BLOCKLY_COLORS.CODE, inputsInline: true }),
      [{ forValue: "value", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Hallo" } }]
    ),
    BH.withNested(
      BH._custom("ALERT", "🌀 alert({{value}})", "alert({{value}});", { colour: BLOCKLY_COLORS.CODE, inputsInline: true }),
      [{ forValue: "value", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Hallo" } }]
    ),
    BH._custom("DEBUG_CARD", "🪲 debug im Chat\n{{msg:text=Debug Titel}} {{obj}}", `RAGAI.CARDS.html("<div class='alert alert-info'><b>" + {{msg}}+ "</b><pre>" + JSON.stringify({{obj}}, null, 2) + "</pre></div>");`, { colour: BLOCKLY_COLORS.CARDS }),
    BH.withNested(
      BH._custom("DEBUG_TOASTR", "🪲 debug mit toastr {{title}} {{msg}}", `RAGAI.toastr.info({{msg}}, {{title}});`, { colour: BLOCKLY_COLORS.TOASTR }),
      [
        { forValue: "title", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Debug Titel" } },
        { forValue: "msg", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Debug Nachricht" } }
      ]
    ),
    BH.withNested(
      BH._custom("DEBUG_LOG_ENTRY", "🪲 Debug-Log Eintrag\nTitel: {{title}}\nGrund: {{reason}}", `await RAGAI.DEBUG.log({{title}}, {{reason}});`, { colour: BLOCKLY_COLORS.CODE, inputsInline: false }),
      [
        { forValue: "title", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Mein Debug-Eintrag" } },
        { forValue: "reason", isShadow: true, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "" } }
      ]
    ),
    BH.withNested(BH.styling("LOAD_EXTERNAL_CSS_IN_BOT", "Bot-Ansicht: Lade externe CSS-Datei {{url[@check=URL] }}", "await RAGAI.DOM.loadExternalCSS({{url}});"),
      [{ forValue: "url", isShadow: true, targetBlockType: 'DUMMY_URL' }]
    ),
    BH.withNested(BH.styling("LOAD_EXTERNAL_JS_IN_BOT", "Bot-Ansicht: Lade externe JS-Datei {{url[@check=URL] }}", "await RAGAI.DOM.loadExternalJS({{url}});"),
      [{ forValue: "url", isShadow: true, targetBlockType: 'DUMMY_URL' }]
    )
  ];
  return cat;
}

export function BlocklyCategory_HELPERS_IF(name: string = "unnamed", BH: BlocklyHelperService, includePrerequisites: boolean = true) {
  const cat: BlocklyToolboxCategory = { kind: 'category', name: name, contents: [] };
  cat.contents = [
    BH.label("Bedingungen"),
    BH._custom("RAG_IF", "prüfe ob {{a}} dann tu {{actions:statement}}", "if({{a}}){\n  {{actions}}}\n", { inputsInline: true }),
    BH._custom("RAG_IF_ELSE", "prüfe ob {{a}} dann tu {{actions:statement}} sonst tu {{actions2:statement}}", "if({{a}}){\n  {{actions}}} else {\n  {{actions2}}}\n", { inputsInline: true, colour: BLOCKLY_COLORS.IF }),
    BH.label("Wiederholungen / Schleifen"),
    //    BH._custom("RAG_WHILE", BLOCKLY_BLOCK_PREFIX.LOOP + "wiederhole solange {{a}}\ntu {{actions:statement}}", "while({{a}}){\n  {{actions}}}\n", { inputsInline: true, colour: BLOCKLY_COLORS.LOOP }),
    /*     BH.withNested(
          BH._custom("RAG_FOR", BLOCKLY_BLOCK_PREFIX.LOOP + "wiederhole {{a[@check:Number]}} mal\ntu {{actions:statement}}", "for(let i = 0; i < {{a}}; i++){\n  {{actions}}}\n", { inputsInline: true, colour: BLOCKLY_COLORS.LOOP }),
          [{ forValue: "a", isShadow: true, targetBlockType: BLOCKLY_DUMMY.NUMBER, targetBlockDefaults: { number: 0 } }]
        ), */
    ...(includePrerequisites ? [
      BH.label("Vorraussetzungen"),
      BH._custom("RAG_CONDITION_STARTWITH", "@output:String\n{{a}} startet mit {{b}}" + BLOCKLY_BLOCK_PREFIX.IF_CONDITION, "{{a}}.startsWith({{b}})", { inputsInline: true, colour: BLOCKLY_COLORS.IF_CONDITION }),
      BH._custom("RAG_CONDITION_ENDSWITH", "@output:String\n{{a}} endet auf {{b}}" + BLOCKLY_BLOCK_PREFIX.IF_CONDITION, "{{a}}.endsWith({{b}})", { inputsInline: true, colour: BLOCKLY_COLORS.IF_CONDITION }),
      BH._custom("RAG_CONDITION_INCLUDES", "@output:String\n{{a}} beinhaltet {{b}}" + BLOCKLY_BLOCK_PREFIX.IF_CONDITION, "{{a}}.includes( {{b}})", { inputsInline: true, colour: BLOCKLY_COLORS.IF_CONDITION }),
      BH._custom("RAG_CONDITION", "@output:String\n{{a}} {{c:dropdown=ist gleich|==,ist nicht gleich|!=}} {{b}}" + BLOCKLY_BLOCK_PREFIX.IF_CONDITION, "{{a}} {{c}} {{b}}", { inputsInline: true, colour: BLOCKLY_COLORS.IF_CONDITION }),
      BH._custom("RAG_CONDITION_NUM", "@output:String\n{{a}} {{c:dropdown=ist größer als|>,ist größer als oder gleich|>=,ist kleiner als|<,ist kleiner als oder gleich|<=,}} {{b}}" + BLOCKLY_BLOCK_PREFIX.IF_CONDITION, "{{a}} {{c}} {{b}}", { inputsInline: true, colour: BLOCKLY_COLORS.IF_CONDITION }),
      BH._custom("RAG_OPERATION_NOT", "@output:Boolean\nnicht {{a[@check=Boolean]}}", "!({{a}})", { inputsInline: true, colour: BLOCKLY_COLORS.IF_OPERATION }),
      BH._custom("RAG_OPERATION_AND", "@output:String\n{{a}} und\n {{b}}", "{{a}} && {{b}}", { inputsInline: true, colour: BLOCKLY_COLORS.IF_OPERATION }),
      BH._custom("RAG_OPERATION_OR", "@output:String\n{{a}} oder\n {{b}}", "{{a}} || {{b}}", { inputsInline: true, colour: BLOCKLY_COLORS.IF_OPERATION })
    ] : [])


  ];
  return cat;
}


export function BlocklyCategory_HELPERS_MAIL(name: string = "unnamed", BH: BlocklyHelperService) {
  const cat: BlocklyToolboxCategory = { kind: 'category', name: name, contents: [] };
  cat.contents = [
    BH.withNested(
      BH._custom("MAIL_SEND_DIRECT", "📤 Mail senden\n An: {{to}} CC: {{cc}} BCC: {{bcc}} Betreff: {{subject}} Text: {{text}} HTML: {{html}} ", "await RAGAI.MAIL.send({ to: {{to}}, subject: {{subject}}, text: {{text}}, html: {{html}}, cc: {{cc}}, bcc: {{bcc}} });", { colour: BLOCKLY_COLORS.MAIL }),
      [
        {
          forValue: 'to',
          isShadow: true,
          targetBlockType: BLOCKLY_DUMMY.STRING,
          targetBlockDefaults: { text: "example@example.com" }
        },
        {
          forValue: 'subject',
          isShadow: true,
          targetBlockType: BLOCKLY_DUMMY.STRING,
          targetBlockDefaults: { text: "Betreff" }
        },
        {
          forValue: 'text',
          isShadow: true,
          targetBlockType: BLOCKLY_DUMMY.STRING,
          targetBlockDefaults: { text: "" }
        },
        {
          forValue: 'html',
          isShadow: true,
          targetBlockType: BLOCKLY_DUMMY.STRING,
          targetBlockDefaults: { text: "" }
        },
        {
          forValue: 'cc',
          isShadow: true,
          targetBlockType: BLOCKLY_DUMMY.STRING,
          targetBlockDefaults: { text: "" }
        },
        {
          forValue: 'bcc',
          isShadow: true,
          targetBlockType: BLOCKLY_DUMMY.STRING,
          targetBlockDefaults: { text: "" }
        }
      ])

  ];
  return cat;
}

export function BlocklyCategory_HELPERS_CALC(name: string = "unnamed", BH: BlocklyHelperService) {
  const cat: BlocklyToolboxCategory = { kind: 'category', name: name, contents: [] };
  cat.contents = [
  ];

  return cat;

}


export const BLOCKLY_COMPLETIONROLES = ["user", "assistant", "system", "developer"];
export function BlocklyCategory_HELPERS_AIGENERATORS(name: string = "unnamed", BH: BlocklyHelperService) {
  const cat: BlocklyToolboxCategory = { kind: 'category', name: name, contents: [] };

  cat.contents = [
    BH.label("Bild"),
    {
      kind: 'block',
      type: 'AIIMAGE_GENERATE_DETAILED',
      inputs: {
        PROMPT: { block: { type: BLOCKLY_DUMMY.STRING, fields: { text: "Strandkörbe am Meer" } } }
      }
    } as any,


    BH.label("Bildanalyse"),
    BH.withNested(
      BH.overlay(
        "OVERLAY_UPLOAD_IMAGE_ANALYSE",
        "Bildanalyse:\nTitel:{{text}}\nHinweis:{{instruktion}}\n Analyseprompt {{prompt}}\n" + OVERLAY_PLACEMENT,
        `await RAGAI.OVERLAY.setPlacement({{placement}});
            RAGAI.OVERLAY.uploadImage({{text}},{{instruktion}}, async function(fileContent,fileName,fileType){
            await RAGAI.CARDS.html("<i class='ri-file-image-line'></i>"+fileName, );
            await RAGAI.OVERLAY.loading("Bitte warten..");
            let answer = await RAGAI.AIIMAGE_OPENAI.analyzeImage(fileContent,{{prompt}});
            RAGAI.OVERLAY.close();
            RAGAI.MSG.botMessage(answer);
          });`
      ),
      [
        {
          forValue: 'prompt',
          isShadow: false,
          targetBlockType: BLOCKLY_DUMMY.STRING,
          targetBlockDefaults: { text: "Was siehst du auf dem Bild" }
        },
        {
          forValue: 'instruktion',
          isShadow: false,
          targetBlockType: BLOCKLY_DUMMY.STRING,
          targetBlockDefaults: { text: "Bild hierher ziehen(PNG, JPEG, WEBP, Non - animated GIF)" }
        },
        {
          forValue: 'text',
          isShadow: false,
          targetBlockType: BLOCKLY_DUMMY.STRING,
          targetBlockDefaults: { text: "Bild hochladen" }
        }
      ])




  ];

  // Deprecated: nur registrieren für bestehende Workspaces
  BH._custom(
    "BOT_BYPASS_THREAD",
    BLOCKLY_CARD_PREFIX.AI_HELPERS + ` - [CONFIG]\nDialog durch Chat-Completion-API
Temperature: {{temperature:number=1}}
Mitsenden der letzten {{msgCount:number=100}} Nachrichten`,
    `if (window.location.pathname.includes("audio") || window.location.pathname.includes("avatar")) {
  RAGAI.EVENTS.listenTo("RAGAI.AUDIO.botSayEnded", async function () {
    await window.RAGAI.AUDIO.attService.startRecording();
  });
}
RAGAI.EVENTS.on("RAGAI.MSG.userBypass", async function(eventName, eventData){
    messages.push({ role:"system", content: eventData.text });
});

const messages = (await RAGAI.DIALOGSTORE.getCurrentDialog()).map(function (msg) {return {role: msg.role, content: msg.content};});
RAGAI.BEFORE_SEND.add(async function (message) {
  messages.push({ role:"user", content: message });
  RAGAI.MSG._addMessagesToThread([messages[messages.length - 1]]);
  let send = messages.slice(-{{msgCount}});
  console.log("MSG ARRAY",send);
  const res = await RAGAI.AITEXT_OPENAI._complexCompletion({ model: "gpt-4o-mini", temperature: {{temperature}} }, send, "openai", false);
  messages.push({ role:"assistant", content: res });
  RAGAI.MSG.botMessage(res);
  return null;
});`, { colour: BLOCKLY_COLORS.RAGAI_DARK, inputsInline: true });

  BH.withNested(
    BH.overlay(
      "OVERLAY_UPLOAD_IMAGE_ANALYSE_WITH_IMAGE",
      "Bildanalyse mit Bild im Chat:\nTitel:{{text}}\nHinweis:{{instruktion}}\n Analyseprompt {{prompt}}\n" + OVERLAY_PLACEMENT,
      `await RAGAI.OVERLAY.setPlacement({{placement}});
            RAGAI.OVERLAY.uploadImage({{text}},{{instruktion}}, async function(fileContent,fileName,fileType){
            await RAGAI.CARDS.image(fileContent, fileName);
            await RAGAI.OVERLAY.loading("Bitte warten..");
            let answer = await RAGAI.AIIMAGE_OPENAI.analyzeImage(fileContent,{{prompt}});
            RAGAI.OVERLAY.close();
            RAGAI.MSG.botMessage(answer);
          });`
    ),
    [
      { forValue: 'prompt', isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Was siehst du auf dem Bild" } },
      { forValue: 'instruktion', isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Bild hierher ziehen(PNG, JPEG, WEBP, Non - animated GIF)" } },
      { forValue: 'text', isShadow: false, targetBlockType: BLOCKLY_DUMMY.STRING, targetBlockDefaults: { text: "Bild hochladen" } }
    ]
  );

  return cat;

}
